"use client"

import SettingsView from "@/components/Settings/SettingsView";

export default function SettingsPage() {
    return <SettingsView />;
}
